import { Skeleton } from '@/components/ui/skeleton';

export function SurveyDetailSkeleton() {
  return (
    <div className="flex flex-col gap-5">
      <div className="rounded-xl border bg-card p-6 shadow-sm">
        <div className="flex flex-col gap-3">
          <div className="flex items-start justify-between gap-3">
            <Skeleton className="h-7 w-2/3" />
            <Skeleton className="h-6 w-16" />
          </div>
          <Skeleton className="h-4 w-4/5" />
          <div className="flex flex-wrap items-center gap-3">
            <Skeleton className="h-4 w-48" />
            <Skeleton className="h-5 w-24" />
          </div>
          <div className="mt-1 grid grid-cols-1 gap-3 sm:grid-cols-3">
            <Skeleton className="h-14" />
            <Skeleton className="h-14" />
            <Skeleton className="h-14" />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <Skeleton className="h-6 w-24" />
        <Skeleton className="h-4 w-20" />
      </div>
      <Skeleton className="h-32" />
      <Skeleton className="h-32" />
    </div>
  );
}
